export default "__VITE_ASSET__f2c7a739__"